<template>
  <nav class="navbar top-nav" role="navigation" aria-label="main navigation">
    <div class="navbar-brand">
      <div class="navbar-item">
        <img src="/static/images/logo.png" />
      </div>
    </div>
    <div class="navbar-menu">
      <div class="navbar-end">
        <div class="navbar-item has-dropdown is-hoverable">
          <a class="navbar-link">
            <strong>{{ user.firstName }} {{ user.lastName }}</strong>
          </a>
          <div class="navbar-dropdown">
            <router-link class="navbar-item" to="/settings/preferences">
              <i class="fal fa-cogs"></i> Inställningar
            </router-link>

            <a class="navbar-item" @click="logout()">
              <i class="fal fa-sign-out"></i> Logga ut
            </a>
          </div>
        </div>

      </div>
    </div>
  </nav>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  computed: {
    ...mapState('auth', ['status', 'user'])
  },
  methods: {
    ...mapActions('auth', ['logout'])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/nav/TopNav.vue